import React, { memo, useMemo } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { FullPageAppTemplate } from 'modules/app-registry/templates'
import { createChildAppOnNavigate } from 'modules/app-registry/utils'
import { useNavigate } from 'react-router-dom'
import { useUserCompanies, useUserContext } from 'shared/hooks'

import { useAvailableApps } from '../../hooks/useAvailableApps'

const HRApp = memo(
  () => {
    const navigate = useNavigate()
    const { user } = useUserContext()
    const { apps } = useAvailableApps()
    const { selectedCompany } = useUserCompanies()
    const onNavigate = useMemo(
      () => createChildAppOnNavigate(apps[AppId.HR].path, navigate),
      [apps, navigate]
    )

    return (
      <FullPageAppTemplate
        appId={AppId.HR}
        scope='hr'
        envKey={apps[AppId.HR].runtimeEnvKey}
        entryPath='./HRApp'
        url={process.env.REACT_APP_EMPLOYEES_APP_DEV_PATH}
        appName={apps[AppId.HR].name}
        appProps={{
          user,
          initialPath: apps[AppId.HR].path,
          organizationName: selectedCompany?.name || '-',
          onNavigate
        }}
      />
    )
  },
  // when there are no props, this is OK to use. without this comparison function, we will have higher memory usage
  () => true
)

export { HRApp }
